// 引入api请求方法
import { formatMoneyConvert } from '@/utils';
import {
  getNybTransDetail,
  getNybTransDetailStatistic,
  nybTransDetailExportUrl,
} from '@/api/account';
import { transTypes, consumerTypes } from '@/utils/dictionary/account';

const storeModuleName = 'transDetailModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'select',
      param: 'transType',
      value: '',
      valueType: 'string',
      state: 'transTypes',
      label: '交易类型',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'date-picker',
      param: 'insertTime',
      value: [],
      valueType: 'date',
      label: '交易时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['startTime', 'endTime'],
    },
    {
      style: 'select',
      param: 'consumerType',
      value: '',
      valueType: 'string',
      state: 'consumerTypes',
      label: '收支类型',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
  ],
  // tabs筛选项
  isSpecialTabs: false,
  isExport: {
    isShow: false,
    method: 'get',
    url: `${nybTransDetailExportUrl}`,
  }, // 导出
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '交易编号',
        prop: 'transCode',
        width: 210,
        checked: 1,
        sortable: true,
      },
      {
        label: '交易类型',
        prop: 'consumerTypeName',
        width: 130,
        checked: 1,
        sortable: true,
      },
      {
        label: '交易金额（元）',
        prop: 'amount',
        width: 120,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-amount',
      },
      {
        label: '变动后余额',
        prop: 'balance',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-balance',
      },
      {
        label: '交易时间',
        prop: 'transTime',
        width: 200,
        checked: 1,
        sortable: true,
      },
      {
        label: '收支类型',
        prop: 'paymentType',
        width: 120,
        checked: 1,
        sortable: true,
      },
      {
        label: '所属运单',
        prop: 'wxWaybillNum',
        width: 120,
        checked: 1,
        sortable: true,
      },
      {
        label: '所属自有车订单',
        prop: 'zyWaybillNum',
        width: 120,
        checked: 1,
        sortable: true,
      },
      {
        label: '所属通行交易',
        prop: 'transactionId',
        width: 180,
        checked: 1,
        sortable: true,
      },
    ],
  },
  companyList: [], // 企业列表
  companyInfo: '', // 当前选中的企业信息
  transTypes,
  consumerTypes,
  statisticsTxt: '',
  startTime: '',
  endTime: '',
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    if (params.startTime && params.endTime) {
      params.startTime = Date.parse(new Date(params.startTime));
      params.endTime = Date.parse(new Date(params.endTime));
    } else {
      params.startTime = '';
      params.endTime = '';
    }

    // 获取统计信息
    const param = Object.assign({}, params, context.state.postParams);
    context.commit('upStartTime', params.startTime);
    context.commit('upEndTime', params.endTime);
    const { data } = await getNybTransDetail(param);
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data),
    });
    context.dispatch('getStatistics');
    return data.list;
  },

  // 获取统计数据
  getStatistics: async context => {
    let statisticsTxt = '';
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    if (params.startTime && params.endTime) {
      params.startTime = Date.parse(new Date(params.startTime));
      params.endTime = Date.parse(new Date(params.endTime));
    }
    const param = Object.assign({}, params, context.state.postParams);
    const { code, data } = await getNybTransDetailStatistic(param);
    if (code === 200 && data) {
      const abs = true;
      statisticsTxt = `共计：${data.totalCount}条；其中：储值：${
        data.rechargeCount
      }条，${formatMoneyConvert({
        money: data.rechargeAmount,
        abs,
      })}元；退款：${data.rushOutCount}条、${formatMoneyConvert({
        money: data.rushOutAmount,
        abs,
      })}元；外调车消费：${data.wxConsumeCount}条、${formatMoneyConvert({
        money: data.wxConsumeAmount,
        abs,
      })}元；自由车消费：${data.zyConsumeCount}条、${formatMoneyConvert({
        money: data.zyConsumeAmount,
        abs,
      })}元；账户余额：${formatMoneyConvert({
        money: data.accountBalance,
        abs,
      })}元、可用余额：${formatMoneyConvert({
        money: data.availableBalance,
        abs,
      })}元`;
    }
    context.commit('updateState', {
      key: 'statisticsTxt',
      value: statisticsTxt,
    });
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        item.value = '';
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        break;
      default:
        break;
    }
  },
  upStartTime(state, payload) {
    state.startTime = payload;
  },
  upEndTime(state, payload) {
    state.endTime = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
